import { judgeActivePage } from 'common/tool'
import CONFIG from '@/config/config.js';

// 分环境打包  设置默认的soket路径
let wssUrl = ''


// 分环境打包  设置默认的wss路径
console.log(process.env.NODE_ENV)
const env = process.env.VUE_APP_CURENV || 'dev';  // 或根据实际来源判断
wssUrl = (CONFIG.env[env] || CONFIG.env.dev).wssUrl;

console.log(wssUrl); // 打印当前环境对应的 baseUrl




let Socket = null
let setIntervalWesocketPush = null ///心跳定时器
let userId = ''
let vm = null ///this 创建soket传来的this
let SocketFlang = true ////soket标志位，手动断开之后，不需要在回调重新连接了
/**建立连接 */
export function createSocket(_vm) {
  if (!Socket) {
    SocketFlang = true
    console.log('建立websocket连接')
    userId = sessionStorage.getItem('userId') ///浏览器缓存读取userId
    vm = _vm ///存储this
    let USER_WSS_URL = ReturnWssBaseUrl() + userId //拼接soket地址
    console.log(USER_WSS_URL)
    Socket = new WebSocket(USER_WSS_URL) ///创建
    Socket.onopen = onopenWS //绑定打开soket的回调 ,绑定心跳
    Socket.onmessage = onmessageWS ///绑定发送消息的回调
    Socket.onerror = onerrorWS ///绑定链接错误的回调
    Socket.onclose = oncloseWS ///绑定关闭soket的回调
  } else {
    console.log('websocket已创建并连接')
  }
}
/**打开WS之后发送心跳 */
export function onopenWS() {
  sendPing() //发送心跳
}
/**连接失败重连 */
export function onerrorWS() {
  setTimeout(() => {
    console.log('soket链接失败，准备重新链接')
    if (SocketFlang) {
      ////说明现在是打开链接的状态，异常之后需要做重连处理
      clearInterval(setIntervalWesocketPush) ///清楚心跳定时器
      if (Socket) {
        Socket.close()
        Socket = null
      }
      createSocket(vm) //重连
    } else {
      ////说明现在是强制关闭链接的状态，如果有重连回调则一直进行关闭操作
      if (Socket) {
        Socket.close()
        Socket = null
      }
    }

  }, 5000)

}
/**WS数据接收统一处理 */
export function onmessageWS(e) {
  // console.log(e)
  if (e.data === '连接成功') {
    console.log('websoket连接成功')
    if (!SocketFlang) {
      ////说明现在是强制关闭链接的状态，如果重连成功，则关闭它
      closeSoket()
    }
  } else {
    let serveDeviceStateData = JSON.parse(e.data)
    updataPageState(serveDeviceStateData) //对拿到的数据进行状态同步更新
    console.log(JSON.parse(e.data))
  }
}
/**发送数据
 * @param eventType
 */
export function sendWSPush(eventTypeArr) {
  const obj = {
    appId: CONFIG.appId,
    cover: 0,
    event: eventTypeArr
  }
  console.log("soket状态" + Socket.readyState)
  if (Socket !== null && Socket.readyState === 3) {
    clearInterval(setIntervalWesocketPush) ///清楚心跳定时器
    if (Socket) {
      Socket.close()
      Socket = null
    }
    // Socket.close()
    createSocket(vm) //重连
  } else if (Socket.readyState === 1) {
    Socket.send(JSON.stringify(obj))
  } else if (Socket.readyState === 0) {
    setTimeout(() => {
      Socket.send(JSON.stringify(obj))
    }, 3000)
  }
}
/**关闭WS */
export function oncloseWS() {
  ///监听关闭事件
  ////说明现在是打开链接的状态，异常之后需要做重连处理、
  if (SocketFlang) {
    console.log('websocket已被动断开，准备重连')

  } else {
    clearInterval(setIntervalWesocketPush) ///清楚心跳定时器
    console.log('websocket已彻底断开不会重连')
  }

}
/**发送心跳 */
export function sendPing() {
  sendWSPush('ping')
  setIntervalWesocketPush = setInterval(() => {
    console.log("web心跳")
    sendWSPush('ping')
  }, 5000)
}
/**关闭soket */
export function closeSoket() {
  clearInterval(setIntervalWesocketPush) ///清楚心跳定时器
  console.log(Socket)
  if (Socket) {
    Socket.close()
    console.log('websocket已手动断开')
    Socket = null
    SocketFlang = false ///强制断开标志位
  }
  console.log('websocket已手动断开')
  console.log(Socket)
}
////页面状态更新
export function updataPageState(serveDeviceData) {
  ///根据服务端发来的全部数据，///判断当前活跃的页面更新当前页面设备的状态
  // vm.$store.dispatch('asyUpdatahomeServeData', data) ///异步提交当前页面需要展示的控制数据,用于状态更新
  // vm.$store.dispatch('asyUpdataregionServeData', {}) ///异步提交当前页面需要展示的控制数据,用于状态更新
  console.log(judgeActivePage())
  if (judgeActivePage() === '区域') {
    let regiondeviceList = vm.$store.state.publicinfo.regionServeData.deviceList
    // console.log(regionServeData) ///拿到区域页面数据
    dataStateHandle(serveDeviceData, regiondeviceList) ///处理数据
  } else if (judgeActivePage() === '常用') {
    let homedeviceList = vm.$store.state.publicinfo.homeServeData.deviceList
    // console.log(homeServeData) ///拿到常用页面数据
    dataStateHandle(serveDeviceData, homedeviceList) ///处理数据
  }
}
export function dataStateHandle(serveDeviceData, deviceList) {
  ////数据处理
  let deviceListlength = deviceList.length
  let serveDeviceDatalength = serveDeviceData.length
  console.log(deviceListlength)
  console.log(serveDeviceDatalength)
  for (let i = 0; i < serveDeviceDatalength; i++) {
    if (serveDeviceData[i].deviceId) {
      for (let l = 0; l < deviceListlength; l++) {
        // console.log(serveDeviceData[i].deviceId)
        // console.log(deviceList[l].deviceId)
        if (serveDeviceData[i].deviceId === deviceList[l].deviceId) {
          console.log(serveDeviceData[i])
          deviceList.splice(l, 1, serveDeviceData[i]) ///更新数据
          // serveDeviceData.splice(i, 1) ///删除已经更新的数据，提高效率
          // serveDeviceDatalength-- ///源数据长度减去1
          break ///退出本层循环
        }
      }
    } else {
      console.log('该设备不需要状态更新' + serveDeviceData[i])
    }
  }
}


const ReturnWssBaseUrl = () => {
  if (sessionStorage.getItem('selectServerState') === 'user') {
    let serverIp = sessionStorage.getItem('userServeIp')
    if (serverIp.indexOf("https:") != -1) {
      ///说明包含https这几个字符
      serverIp = serverIp.replace('https:', 'wss:');
      console.log(serverIp)
    } else if (serverIp.indexOf("http:") != -1) {
      ///说明包含http这几个字符
      serverIp = serverIp.replace('http:', 'ws:');
      console.log(serverIp)
    } else {
      console.log('用户设置了不合法的服务器IP')
      serverIp = ''
      console.log(serverIp)
    }
    console.log('返回用户设置的websoket服务器IP')
    return serverIp + '/monitor/'


  } else {
    console.log('返回系统设置的websoket服务器IP')
    return wssUrl
  }
}
